import { RouteLocationRaw } from "vue-router"

import { Team } from "@/models/Team"
import { wait } from "@/plugins/vuewait"
import { Actions, Getters, store } from "@/store"

export default async (
  to,
  from,
  next: (arg?: RouteLocationRaw) => void
): Promise<void | boolean> => {
  if (to.path === from.path) {
    return next()
  }
  wait.start("checkUserInItem")
  await store.dispatch(Actions.RESET_ITEM)
  const sessionItemId = store.getters[Getters.GET_SESSION_ITEM_ID]
  if (!sessionItemId) {
    wait.end("checkUserInItem")
    return next()
  }
  const sessionItem = await store.dispatch(Actions["GET_ITEM"], {
    itemId: sessionItemId
  })

  if (to.query.showStoryPoker && sessionItem.team) {
    const currentProfile = store.getters[Getters.GET_USER_CURRENT_PROFILE]
    const currentTeam: Team = await store.dispatch(Actions.TEAM_WITH_EXTENDED_USERS, {
      teamId: sessionItem.team.id,
      onlyGet: true
    })
    const checkUserInTeam = currentTeam.users.find(user => user.id === currentProfile.id)
    if (!checkUserInTeam) {
      return next({
        name: "Error",
        query: {
          code: 404
        }
      })
    }
  }
  wait.end("checkUserInItem")
  next()
}
